import { useQuery } from '@tanstack/react-query';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getManagerDevices: managerTypes.GetManagerDevices = () => {
  return axios.get('/managers/devices');
};

type QueryFnType = typeof getManagerDevices;

type UseGetManagerDevices = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetManagerDevices = ({ config = {} }: UseGetManagerDevices = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['managers', 'devices'],
    queryFn: () => getManagerDevices(),
  });
};
